import { Navigate } from 'react-router-dom'

import { TeamRole } from '@/consts/team'
import { useTeamStore } from '@/stores/team'

interface ProtectedTeamRouteProps {
  children: React.ReactNode
  allowedRoles: TeamRole[]
  redirectTo?: string
}

/**
 * Route Guard for team pages requiring specific roles
 *
 * Usage:
 * <ProtectedTeamRoute allowedRoles={[TeamRole.Owner, TeamRole.Admin]}>
 *   <AdminOnlyPage />
 * </ProtectedTeamRoute>
 */
export function ProtectedTeamRoute({
  children,
  allowedRoles,
  redirectTo = '/team/home',
}: ProtectedTeamRouteProps) {
  const teamStore = useTeamStore()
  const userRole = teamStore.teamTokenData?.userRole || TeamRole.Normal

  // Check if user has required role
  if (!allowedRoles.includes(userRole)) {
    return <Navigate to={redirectTo} replace />
  }

  return <>{children}</>
}
